<div class="container-fluid d-md-none px-0">
  <div class="row">
      <div class="col">
          <div id="mobile-hero">
              <img [src]="active_category?.image_url" [alt]="title">
              <h3 class="playball-regular text-white h1">{{ title }}</h3>
          </div>
      </div>
  </div>
</div>